function getBoxes() {
    return Array.from(document.querySelectorAll(".testimonial-box"));
}


function sortBoxes(value) {
    const wrapper = document.querySelector(".reviews_sec .container");
    let boxes = getBoxes();

    // Reset hidden state
    boxes.forEach(box => {
        box.dataset.hidden = "false";
    });

    if (value === "pineal-xt" || value === "pineal-guardian") {

        // Filter products
        boxes.forEach(box => {
            if (box.dataset.product !== value) {
                box.dataset.hidden = "true";
            }
        });

    } else {

        // Sort
        boxes.sort((a, b) => {

            if (value === "featured") {
                const featuredDiff =
                    Number(b.dataset.featured) - Number(a.dataset.featured);

                if (featuredDiff !== 0) return featuredDiff;

                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            if (value === "recent") {
                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            if (value === "oldest") {
                return Number(b.dataset.date) - Number(a.dataset.date);
            }

            if (value === "highest") {
                const ratingDiff =
                    Number(b.dataset.rating) - Number(a.dataset.rating);

                if (ratingDiff !== 0) return ratingDiff;

                return Number(a.dataset.date) - Number(b.dataset.date);
            }

            return 0;
        });

           boxes.forEach(box => wrapper.appendChild(box));
    }
      boxes.forEach(box => {
        box.style.display = box.dataset.hidden === "true" ? "none" : "";
    });

}

// Initial load
sortBoxes("featured");



// Dropdown change
document.querySelector(".feature_txt").addEventListener("change", function () {
    sortBoxes(this.value);
});